import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { interval, Observable, pipe, startWith, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { CodesReelService } from '../../services/codes-reel.service';
import { CodesReelModel } from '../../models/codes-reel.model';
import { CodesRollerComponent } from '../../components/codes-roller/codes-roller.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AuctionsService } from '../../services/auctions.service';
import { Category } from '../../models/category.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { CategoryFilterComponent } from '../../components/category-filter/category-filter.component';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-codes-reel',
  imports: [CodesRollerComponent, CategoryFilterComponent],
  templateUrl: './codes-reel.component.html',
  styleUrl: './codes-reel.component.scss',
})
export class CodesReelComponent implements OnInit, OnDestroy {
  private codesReelService = inject(CodesReelService);
  private readonly destroy$: Subject<void> = new Subject<void>();
  public codes: WritableSignal<CodesReelModel[]> = signal([]);
  private route = inject(ActivatedRoute);
  private auctionsService: AuctionsService = inject(AuctionsService);
  open = signal(false);

  categoryId = this.route.snapshot.paramMap.get('id');

    protected codesCategories: Signal<Category[]> = toSignal(
    this.pollEvery(30000, () => this.auctionsService.getCodesWithCount()),
    { initialValue: [] }
  );

   constructor(private router: Router, private messages: MessageService){}

  public ngOnInit(): void {
    this.fetchCodesReel();
    interval(3000)
      .pipe(
        startWith(0),
        pipe(takeUntil(this.destroy$)),
        tap(() => this.fetchCodesReel())
      )
      .subscribe();
  }

  public reserveCode(code: CodesReelModel): void {
    this.codesReelService
      .reserveCode(code.id)
      .subscribe(() => this.fetchCodesReel());
  }

  private fetchCodesReel(): void {
    if (this.categoryId) {
      this.codesReelService
        .getCodesReelForCategory(this.categoryId!)
        .pipe(
          tap((reel) => this.codes.set(reel)),
          takeUntil(this.destroy$)
        )
        .subscribe({
          next: () => {},
          error: () => this.codes.set([]),
        });
    } else {
      this.codesReelService
        .getCodesReel()
        .pipe(
          tap((reel) => this.codes.set(reel)),
          takeUntil(this.destroy$)
        )
        .subscribe({
          next: () => {},
          error: () => this.codes.set([]),
        });
    }
  }

   filterDataForFocusedView() {
     return  this.codesCategories();
  }

    private pollEvery<T>(ms: number, getFn: () => Observable<T>) {
      return interval(ms).pipe(
        startWith(0),
        switchMap(() => getFn()),
        takeUntil(this.destroy$)
      );
    }

    public filterAuctions(categoryId: string): void {

      this.auctionsService
        .getCodesListByCategory(categoryId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (codesList: any) => {
            this.router.navigate(['/codes-reel/', categoryId], {
              state: { codesList },
            });
          },
          error: (error) => {
            console.error('getCodesListByCategory failed', error);
          },
        });

      return;

  
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
